import { signOut } from "firebase/auth";
import { auth } from "./auth";

const BASE_URL = process.env.REACT_APP_API_URL;

// Real sign-out.
//
// "Log Out" in the top bar used to be a <Link to="/">: it navigated home and did
// nothing else. The Firebase session stayed signed in, sessionStorage kept the
// session token, and the ris_sessions row stayed live until it aged out — so
// anyone reaching the machine afterwards was still logged in, and a token
// captured beforehand kept working. Now that the backend checks that row on
// every request, deleting it server-side is what actually ends access.
//
// Order matters: tell the server first (that call needs credentials), then drop
// the Firebase session, then clear local state.
export async function performLogout() {
  const sessionToken = sessionStorage.getItem("sessionToken");

  if (BASE_URL && sessionToken) {
    try {
      // Goes through the patched global fetch, which attaches the ID token and
      // X-Session-Token. Best-effort: a network failure must not strand the user
      // in a half-logged-out state, so local sign-out still proceeds below.
      await fetch(`${BASE_URL}/RIS/logout`, { method: "POST" });
    } catch {
      /* ignore — local sign-out continues regardless */
    }
  }

  try {
    await signOut(auth);
  } catch {
    /* ignore */
  }

  sessionStorage.removeItem("sessionToken");
  sessionStorage.removeItem("user");
  sessionStorage.removeItem("currentPatient");
}
